import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Loading, Page } from '@/components/ui/Page';
import historyIllustration from '@/assets/img/history-top-side-img.png';
import checkIcon from '@/assets/svg/check.svg';
import { useUserSessions } from '@/hooks/useUserSessions';
import { Button } from '@/components/ui/Button';

export default function HistoryPage() {
  const navigate = useNavigate();
  const { sessions, loading } = useUserSessions();
  const items = useMemo(
    () => sessions.filter((session) => session.endId || session.end),
    [sessions],
  );
  return (
    <Page>
      <div className="mx-auto flex min-h-[calc(100dvh-105px)] w-full max-w-xl flex-col items-center pb-28 text-center">
        <div
          className="h-56 w-full rounded-xl bg-[#fde0d1] bg-right-bottom bg-no-repeat px-6 py-7 text-left shadow-sm"
          style={{ backgroundImage: `url(${historyIllustration})` }}
        >
          <h2 className="text-2xl font-semibold text-[#535d7e]">История сессий</h2>
          <p className="mt-3 text-4xl font-bold text-[#535d7e]">{items.length}</p>
          <p className="text-[#535d7e]">Завершено</p>
        </div>
        {loading && <Loading />}
        <div className="relative -mt-5 grid w-[calc(100%-2rem)] gap-3">
          {items.map((item) => (
            <div
              key={item.id}
              className="relative h-24 overflow-hidden rounded-xl border border-gray-200 bg-white text-left shadow-sm"
            >
              <div className="flex h-full items-center gap-4 px-5 pb-1">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-green-300 text-green-500">
                  <img src={checkIcon} alt="" className="h-6 w-6" />
                </span>
                <div className="min-w-0 flex-1 text-center">
                  <p className="truncate text-xs font-medium text-gray-500">
                    {item.store?.number} {item.store?.title}
                  </p>
                  <p className="mt-1 text-xl font-semibold leading-6 text-[#535d7e]">
                    {moment(item.begin?.createdAt).format('HH:mm')} —{' '}
                    {moment(item.end?.createdAt).format('HH:mm')}
                  </p>
                  <p className="text-right text-xs italic text-[#535d7e]">
                    {moment(item.begin?.createdAt).format('DD.MM.YYYY')}
                  </p>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 h-1 w-3/5 bg-green-400" />
            </div>
          ))}
        </div>
        <div className="fixed bottom-4 left-1/2 z-30 flex w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 justify-start">
          <Button
            type="button"
            variant="neutral"
            className="min-h-20 min-w-24 gap-2 shadow-md"
            onClick={() => navigate('/')}
          >
            <span aria-hidden="true">←</span>
            Сегодня
          </Button>
        </div>
      </div>
    </Page>
  );
}
